<template>
    <div>
        <slot v-bind="this" />
    </div>
</template>

<script>
    export default {
        props: {
            data: {
                type: Object,
                default: () => ({
                    visuals: null,
                })
            }
        },
        data() {
            return {
                visuals: this.data.visuals,
            }
        },
        computed: {
            hasVisuals() {
                return (this.visuals || []).length > 0;
            },
        },
        methods: {
            handleVisualsChanged(visuals) {
                this.visuals = visuals;
            }
        },
    }
</script>